// Fisher–Yates shuffle
export const shuffle = (originalArray: any[]) => {
  const array = new Array(...originalArray);
  let oldElement;
  for (let i = array.length - 1; i > 0; i--) {
    const rand = Math.floor(Math.random() * (i + 1));
    oldElement = array[i];
    array[i] = array[rand];
    array[rand] = oldElement;
  }
  return array;
};
